export const SET_LIST_REPORTS = "SET_LIST_REPORTS"; 
export const SET_LOADING_MONETIZATIONS = "GET_LOADING_MONETIZATIONS";

// Iniciar monetización
export const SET_START_LIST_MONETIZATION = "SET_START_LIST_MONETIZATION";
export const SET_EMAIL_SEND_MONETIZATION = "SET_EMAIL_SEND_MONETIZATION";
export const SET_LIST_MONETIZATION = "SET_LIST_MONETIZATION";

// Confirmar monetización
export const SET_CONFIRM_MONETIZATION = "SET_CONFIRM_MONETIZATION";
export const SET_LIST_CONFIRM_MONETIZATION="SET_LIST_CONFIRM_MONETIZATION";